<template>
  <div class="switch">
    <label class="switch__wrapper">
      <input v-model="getValue" class="switch__input" type="checkbox" />
      <span class="switch__slider" />
    </label>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: Boolean, required: false },
});

const emits = defineEmits(["update:modelValue"]);

const getValue = computed({
  get: () => props.modelValue,
  set: (value) => emits("update:modelValue", value),
});
</script>

<style lang="scss" scoped>
.switch {
  font-size: 0;

  &__wrapper {
    width: 56px;
    height: 32px;

    position: relative;

    display: inline-block;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    @include bigMobile {
      width: 52px;
      height: 28px;
    }
  }

  &__wrapper &__input {
    display: none;
  }

  &__slider {
    position: absolute;
    @include setAbs(0, 0, 0, 0);

    border-radius: 32px;

    background-color: #e3e5e6;

    transition: all 0.2s ease-in-out;

    cursor: pointer;

    &::before {
      content: "";

      width: 28px;
      height: 28px;

      position: absolute;
      @include setAbs(auto, 2px, auto, 2px);

      border-radius: 50%;

      background-color: white;

      transition: all 0.2s ease-in-out;

      @include bigMobile {
        width: 24px;
        height: 24px;
      }
    }
  }

  &__input:checked + &__slider {
    background-color: #f36c21;
  }

  &__input:checked + &__slider:active {
    background-color: #e05507;
  }

  &__input + &__slider:active {
    background-color: #e05507;
  }

  &__input:checked + &__slider:before {
    transform: translateX(24px);
  }
}
</style>
